module.exports = __webpack_public_path__ + "static/img/__9420.ccb9132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9420.jpg
// module id = 0o0+
// module chunks = 0